module.exports = __webpack_public_path__ + "d08be7fef31ee990606753f537250dc4.MP3";